import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';
import Pdfview from '../components/Pdfview';

//import Collapsible from 'react-collapsible';
import Collapse, { Panel } from 'rc-collapse';

import Ctestonebyone from './Ctestonebyone';
import Cnormaltest from './Cnormaltest';
import Cfixedtimetest from './Cfixedtimetest';
import Ctimevariabletest from './Ctimevariabletest';
import Ctestresults from './Ctestresults';

import Cvideocomponent from './Cvideocomponent';
import Canouncement from './Canouncement';
import Cfeedbackform from './Cfeedbackform';

const $=window.$;
const jQuery=window.jQuery;

export default class Careerlaunchertrial extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      product_id: Common.getUserData('productID', true), 
      clist:[], 
      accordinglists:[],
      completedcomp:[],
      total_score:'',
      total_out_of_score:'',
      componentview:false,
      component:'',
      sqe_id:'',
      compo_type :'',
      current_component:"0",
      sub_cur_component:"0"
    };
    this.compolist = this.compolist.bind(this);
  }
 
  getCllist(){
      Common.reactLoader("show", "Please wait...");
      fetch(Config.domainUrl+'careerlancher/gettriallist', {
        method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':'Bearer ' +Common.getTokenData()
            },
            body: JSON.stringify({
              learner_id: User.UserId(),
              product_id: this.state.product_id
            })
      }).then((response) => response.json()).then((responseJson) => {
          this.setState({
            clist:responseJson.result,
            accordinglists:responseJson.result.accordinglists,
            completedcomp:responseJson.competedcomp,
            total_out_of_score:responseJson.total_out_of_score,
            total_score:responseJson.total_score
          });
          setTimeout(()=>{ Common.reactLoader("hide"); }, 1000);
      });
  }

  componentDidMount() { this.getCllist(); }

  trd4(component_list){

    const trd4 = component_list.map((k2,v2)=>{
      let is_completed = $.inArray(k2,this.state.completedcomp)>=0;
      var sp = k2.split("_");
      let imageico='spdf.png';
      let comtitle ='Faculty Session VC';
      if(sp.length>0){
        if(sp[0]=='vc'){
          imageico =(is_completed>0) ? 'cvls.png' : 'vlsc.png';
          comtitle ='Faculty session';
        }
        if(sp[0]=='mcq'){
          imageico =(is_completed>0) ? 'ctesticon.png' : 'testiconc.png';
          comtitle ='Assessment';
        }

        if(sp[0]=='an'){
          imageico =(is_completed>0) ? 'cannouncement.png' : 'announcementc.png';
          comtitle ='Information';
        }

        if(sp[0]=='fb'){
          imageico =(is_completed>0) ? 'cfeedback.png' : 'feedbackc.png';
          comtitle ='Feedback';
        }
      }

      return <a key={k2} href="javascript:void(0);" style={{textDecoration:'none', border:'0px'}} title={comtitle} onClick={e=>this.opencomponents(k2)}>
        <img src={process.env.PUBLIC_URL+'/images/'+imageico} title={comtitle} alt_text={comtitle} />
      </a>
    });
    return trd4;
  }
  trd3(components){

    const trd3 = components.map((k1,v1)=>{ 
      return <div key={"sub"+v1} className={"new-icon ks"+v1}>
        <h4 className="h last-child">{k1.title}</h4>
        <span className="icons-set">{this.trd4(k1.component_list)}</span>
      </div> 
    });
    return trd3;   
  }

  trd2(sub_title, components){

    const trd2 = sub_title.map((k,v)=>{
    return <Collapse key={"sub"+v} accordion={true} defaultActiveKey={`subt_${this.state.sub_cur_component}`} onChange={e=>this.setsubActivityKey(v)}>
      <Panel header={k} key={`subt_${v}`} onChange={e=>this.setsubActivityKey(v)}>
      { components.component_list==undefined && components[v]!=undefined && this.trd3(components[v])}
      { components.component_list!=undefined && this.trd4(components.component_list)}
      </Panel>
      </Collapse>
    });
    return trd2;     
  }

  compolist(cdata){

    if(cdata.compo_type=='testonebyone'){
      let compodet  = this.getcompoformat('complete',cdata.compseq_id,cdata.id,cdata.compotype);
      this.setState({ componentview:true, component: <Ctestresults data={compodet} switchback={this.compolist}/>});
    } else{
      this.state.completedcomp.push(cdata.id);
      this.setState({ componentview:false, component: "" });
      //window.reload();
      this.getCllist();
    }

  }

  opencomponents(component){

    this.setState({ current_component:2 });

    let s = component.split('.');     
    if(s[1] != undefined  && s[1].toLowerCase()=='pdf'){      
      this.setState({ componentview:true, component: <Pdfview key={`pdf_view_0`} pdfpath={Config.rootDomainUrl +"imeta/"+component} title="Read Me - All about this session"/> });
    } else {
      Common.reactLoader("show", "Please wait...");
      let ssd = component.split('_');
      
      fetch(Config.domainUrl+'careerlancher/getcomponent', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization':'Bearer ' +Common.getTokenData()
        },
        body: JSON.stringify({
          learner_id: User.UserId(),
          product_id: this.state.product_id,
          learning_room: Common.getUserData('defaultLRID', true),
          component: component
        })
      }).then((response) => response.json()).then((responseJson) => { 
          this.setState({ componentview:true, component: this.getcompodetails(ssd,responseJson.result) });
          setTimeout(()=>{ Common.reactLoader("hide"); }, 2000);
      });
    }   
    
  }

  getcompoformat(status,compseq_id,id,compotype){
    let data = {
      "status":status,
      "learning_room_id":Common.getUserData('defaultLRID', true),
      "compseq_id":compseq_id,
      "divider_id":"1",
      "dlr_id":0,
      "learner_id":User.UserId(),
      "is_repeat":"N",
      "look_before":"N",
      "divider_status":1,
      "is_ag":"",
      "id":id,
      "name":"",
      "icon":"",
      "alt_text":"",
      "base_line":"",
      "spanclass":"an_active_button",
      "compo_type":compotype,
      "Isvisible":1,
      "current_component": this.state.current_component,
      "sub_current_component": this.state.current_component
    }
    return data;
  }
  getcompodetails(ssd,responseJson){

    let compodet = '';
    let opcompo  = '';
    let compotype= responseJson.compo_type; 

    if(ssd[0]=='mcq'){ 
      compotype = (responseJson.status=='') ? responseJson.compo_type:'testresult';
      compodet  = this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],compotype);
      if(responseJson.status=='completed'){
        opcompo   = <Ctestresults data={compodet} switchback={this.compolist}/>
      } else if(compotype=='testonebyone'){
        opcompo   = <Ctestonebyone data={compodet} switchback={this.compolist}/>
      } else if(compotype=='normaltest'){
        opcompo   = <Cnormaltest data={compodet} switchback={this.compolist}/>
      }
    }
    if(ssd[0]=='vc') {
      compodet = this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],"videocomponent");
      opcompo  = <Cvideocomponent data={compodet} switchback={this.compolist}/>
    } 

    if(ssd[0]=='an') {
      compodet = this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],"anouncement");
      opcompo  = <Canouncement data={compodet} switchback={this.compolist}/>
    }

    if(ssd[0]=='fb') { 
      compodet = this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],"feedbackform");
      opcompo  = <Cfeedbackform data={compodet} switchback={this.compolist}/>
    }

    return opcompo;
  }

  goback(k){  
    this.setState({ componentview:false, component:'' });
    setTimeout(()=>{ this.setState({ current_component:k }) }, 1000);    
  }
  
  setActivityKey(k){
    this.setState({ current_component:k });
  }

  setsubActivityKey(k){
    this.setState({ sub_cur_component:k });
  }

  //{"status":"completed","learning_room_id":"2694","compseq_id":"19006","divider_id":"1","dlr_id":0,"learner_id":"101032","is_repeat":"N","look_before":"N","divider_status":1,"is_ag":"","id":"687","name":"dsf","icon":"dsf","alt_text":"dasfdasf","base_line":"dasf","spanclass":"an_active_button","compo_type":"thanks","Isvisible":1}
  render() {
    let clistsd = this.state.clist;
    let accordinglist = this.state.accordinglists;   

    const trd1 = accordinglist.map((key,index)=>{ 
      
      return <Collapse key={"mn"+index} accordion={true} defaultActiveKey={`cus_${this.state.current_component}`} onChange={e=>this.setActivityKey(index)}>
        <Panel header={key.main_title} key={`cus_${index}`} onChange={e=>this.setActivityKey(index)}>
        <div className="outer" onClick={e=>this.setActivityKey(index)}>      
          { key.sub_title.length>0 && this.trd2(key.sub_title, key.components)}
          { key.sub_title.length==0 && this.trd3(key.components)}
        </div>
        </Panel> 
        </Collapse>  

    })
    
    return (
      
        <div key="trial" id="container2" className="container2">         
          <div id="accrodion">
            <h2>{clistsd.title}</h2>
            <div className="smart-link">
              { clistsd.introduction_vc!='' && clistsd.introduction_vc!=undefined &&
              <p>
                <a href="javascript:void(0);" title={clistsd.introduction_vc} onClick={e=>this.opencomponents(clistsd.introduction_vc)}>
                <img src={process.env.PUBLIC_URL+'/images/video.png'} alt={clistsd.introduction_vc} align="absmiddle"/>&nbsp;&nbsp;{clistsd.introduction_vc_title}
                </a>
              </p>
            }
            { clistsd.introductoin_pdf!='' && clistsd.introductoin_pdf!=undefined &&
                <p>
                <a href="javascript:void(0);" title={clistsd.introductoin_pdf} onClick={e=>this.opencomponents(clistsd.introductoin_pdf)}> 
                <img src={process.env.PUBLIC_URL+'/images/spdf.png'} alt={clistsd.introductoin_pdf} align="absmiddle"/>&nbsp;&nbsp;{clistsd.introductoin_pdf_title}
                </a>
              </p>
            }
            </div>
            
            <div className="completedcomp">
              <img src={process.env.PUBLIC_URL+'/images/smctick.png'} /> &nbsp;Completed   
              { this.state.componentview &&<span>&nbsp; | &nbsp;<a href="javascript:void(0);" onClick={e=>this.goback(this.state.current_component)}>Click here to Go Back</a></span> }
            </div> 
            <div className="clear"></div>

            { this.state.total_score>0 && <div className="perform-score">Performance score: <span>-</span> ({this.state.total_score +'/'+this.state.total_out_of_score})</div> }
            { !this.state.componentview && <div className="accordion" id="acc2"> {trd1} </div> }
            { this.state.componentview && this.state.component }
            
            { this.state.componentview && <div className="completedcomp">
              <img src={process.env.PUBLIC_URL+'/images/smctick.png'} /> &nbsp;Completed    
              { this.state.componentview &&<span>&nbsp; | &nbsp;<a href="javascript:void(0);" onClick={e=>this.goback(this.state.current_component)}>Click here to Go Back</a></span> }
              </div>
            }
          </div>          
        </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Careerlaunchertrial.js